import * as Actions from "./actions";
import * as Path from './apiRoutes';
import ApiService from "../../../../utils/apiService";
import { MSG_DEFAULT_ERROR } from "../../../../utils/messages";
import { NOTIF_ERROR, DATE_FORMAT } from "../../../../utils/constants";
import { SideNotification } from "../../../../utils/common";
import moment from 'moment'
import { isNullOrUndefined } from "util";


export const getCalendarList = (params) => (dispatch) => {
    params.startDate = isNullOrUndefined(params.startDate) ? null : moment(params.startDate).format(DATE_FORMAT)
    params.endDate =  isNullOrUndefined(params.endDate) ? null : moment(params.endDate).format(DATE_FORMAT)
    return ApiService.list(Path.CALENDAR_ROOT, params)
        .then((response) => {
            dispatch(Actions.setList(response.data.data.list));
            return response.data;
        })
        .catch((error) => {
            SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR)
        })
};

export const insertCalendar = (params) => () => {

    params.isOfficer = params.isOfficer ? "1" : "0"
    params = Object.keys(params).filter(key => "startDate" !== key && "endDate" !== key).reduce((obj, key) => { obj[key] = params[key]; return obj; }, {});
    return ApiService.insert(Path.CALENDAR_ROOT, params)
        .then((response) => {
            return response.data
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const updateCalendar = (params) => (dispatch) => {

    params.isOfficer = params.isOfficer ? "1" : "0"
    params = Object.keys(params).filter(key => "startDate" !== key && "endDate" !== key).reduce((obj, key) => { obj[key] = params[key]; return obj; }, {});
    return ApiService.update(Path.CALENDAR_ROOT, params)
        .then((response) => {
            dispatch(getCalendarById(params.calendarId))
            return response.data
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}


export const getCalendarById = (id) => (dispatch) => {
    return ApiService.get(Path.CALENDAR_ROOT + `/${id}`)
        .then((response) => {
            dispatch(Actions.setCalendar(response.data.data));
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const deleteCalendar = (id) => () => {
    return ApiService.delete(Path.CALENDAR_ROOT, id)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};


